import SearchFilters from './search-filters.enum';

export const SEARCH_CONTAINER_HEIGHT = '48px';

export const MIN_SEARCH_LENGTH = 5;
export const MAX_SEARCH_LENGTH = 20;

export const SEARCH_FILTERS: { [key: string]: string } = {
	[SearchFilters.Identification]: 'Identificación',
	[SearchFilters.Email]: 'Correo electrónico',
};
